import React from 'react'
import { Button, Grid } from 'react-bootstrap'
import DocumentTitle from 'react-document-title'
import Backdrop from '../components/backdrop'

/**
 * Internal error page
 */
class InternalError extends React.Component {
  static propTypes = {
    error: React.PropTypes.object
  }

  _goBack () {
    global.history.back()
  }

  render() {
    const {
      response: {
        req = {},
        body = {}
      } = {},
      stack
    } = this.props.error

    return (
      <DocumentTitle title="Internal error">
        <Backdrop url="/images/library.jpg">
          <div className="redi-component-top-nav">
            <Grid fluid>
              <img src="/images/logos/logo-2x.png"/>
            </Grid>
          </div>
          <Grid fluid>
            <h2>Oh no!</h2>
            <p>What did you do?! Actually, it was our issue and our team has been poked.</p>
            <Button onClick={::this._goBack}>Go back</Button>
            {req.url && <pre>API endpoint: {req.url}</pre>}
            <pre>{body.stack || stack}</pre>
          </Grid>
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default InternalError



// WEBPACK FOOTER //
// ./modules/shared/pages/internalError.js